<template>
    <div class="send-voice-tip">开启后，客户可在移动端网页咨询窗口发送{{ type === 'file' ? '文件' : '图片' }}</div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="less">
@help-font-color: #a8abb3;

.send-voice-tip {
    width: 260px;
}
</style>
